export default [
    {
        path: "/workflow/processes",
        name: "processes",
        meta: { title: "Workflow Processes", authRequired: true },
        component: () => import("../views/workflow/processes.vue"),
    },
    {
        path: "/workflow/system/processes",
        name: "system-processes",
        meta: { title: "System Processes", authRequired: true },
        component: () => import("../views/workflow/manage-system-processes.vue"),
    },
    {
        path: "/workflow/processes/new",
        name: "new-process",
        meta: { title: "New Process", authRequired: true },
        component: () => import("../views/workflow/new-process.vue"),
    },
    {
        path: "/workflow/processes/view",
        name: "view-process",
        meta: { title: "View Process", authRequired: true },
        component: () => import("../views/workflow/view-process.vue"),
    },
    {
        path: "/workflow/tasks",
        name: "tasks",
        meta: { title: "New Process", authRequired: true },
        component: () => import("../views/workflow/tasks.vue"),
    },
    {
        path: "/workflow/all-tasks",
        name: "all-tasks",
        meta: { title: "All Tasks", authRequired: true },
        component: () => import("../views/workflow/all-tasks.vue"),
    },
    {
        path: "/workflow/reassign-tasks",
        name: "reassign-tasks",
        meta: { title: "Reassign Tasks", authRequired: true, privileges: ["REALLOCATE_TASKS"] },
        component: () => import("../views/workflow/reassign-tasks.vue"),
    },
    {
        path: "/workflow/task-history",
        name: "task-history",
        meta: { title: "Task History", authRequired: true },
        component: () => import("../views/workflow/task-history.vue"),
    },
    {
        path: "/workflow/unassigned-tasks",
        name: "unassigned-tasks",
        meta: { title: "Unassigned Tasks", authRequired: true, privileges: ["REALLOCATE_TASKS"] },
        component: () => import("../views/workflow/unassigned-tasks.vue"),
    }
]
